import React from "react";
import { Table, Button, Badge, Alert } from "react-bootstrap";
import {
  // IconEdit,
  // IconTrash,
  IconEye,
  // IconCheck,
  // IconX,
} from "@tabler/icons-react";
import { getContrastColor } from "utils/utils";

const PurchaseReceiptTable = ({
  purchaseReceipts,
  // onEdit,
  // onDelete,
  onView,
  // onCancel,
  Pagination,
}) => {
  const getStatusBadgeVariant = (status, isCancelled) => {
    if (isCancelled) return "danger";
    switch (status?.toLowerCase()) {
      case "active":
        return "success";
      case "cancelled":
        return "danger";
      default:
        return "secondary";
    }
  };

  // const formatCurrency = (amount) => {
  //   return new Intl.NumberFormat("id-ID", {
  //     style: "currency",
  //     currency: "IDR",
  //   }).format(amount || 0);
  // };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("id-ID");
  };

  if (purchaseReceipts.error) {
    return (
      <Alert variant="danger">
        <strong>Error loading purchase receipts:</strong>{" "}
        {purchaseReceipts.error}
      </Alert>
    );
  }

  if (!purchaseReceipts.data || purchaseReceipts.data.length === 0) {
    return (
      <Alert variant="info">
        No purchase receipts found. Create your first purchase receipt to get
        started.
      </Alert>
    );
  }

  return (
    <div>
      <div style={{ overflowX: "auto" }}>
        <Table responsive hover>
          <thead className="bg-primary text-white">
            <tr>
              <th>Receipt Number</th>
              <th>Purchase Order</th>
              <th>Warehouse</th>
              <th>Received By</th>
              <th>Received Date</th>
              <th>Status</th>
              <th>Items Count</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {purchaseReceipts.data.map((receipt) => (
              <tr key={receipt.id}>
                <td>
                  <strong>{receipt.receipt_number}</strong>
                </td>
                <td>
                  <strong>{receipt.purchase_order?.po_number}</strong> <br />
                  <small className="text-xs text-secondary">
                    {receipt.purchase_order?.supplier?.name || "-"}
                  </small>
                </td>
                <td>{receipt.purchase_order?.warehouse?.name || "-"}</td>
                <td>{receipt.received_by?.name || "-"}</td>
                <td>{formatDate(receipt.received_at)}</td>
                <td>
                  <Badge
                    bg={getStatusBadgeVariant(
                      receipt.status,
                      receipt.is_cancelled
                    )}
                    style={{
                      color: getContrastColor(
                        getStatusBadgeVariant(
                          receipt.status,
                          receipt.is_cancelled
                        )
                      ),
                    }}
                  >
                    {receipt.is_cancelled ? "Cancelled" : "Received"}
                  </Badge>
                </td>
                <td>{receipt.items?.length || 0} items</td>
                <td>
                  <div className="d-flex gap-1">
                    {onView && (
                      <Button
                        variant="outline-info"
                        onClick={() => onView(receipt)}
                        title="View Details"
                      >
                        <IconEye />
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      {Pagination && (
        <div className="d-flex justify-content-center mt-3">{Pagination}</div>
      )}
    </div>
  );
};

export default PurchaseReceiptTable;
